import axios from "axios";

export const imgUrl = 'https://api.tracksales.cloud/';
export const API_BASE_URL = 'https://api.tracksales.cloud/api/v1/';
// export const imgUrl = 'http://127.0.0.1:9122';
// export const API_BASE_URL = 'http://127.0.0.1:9122/api/v1/';
const apiSalesTracker = axios.create({
    baseURL: API_BASE_URL,
});

apiSalesTracker.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (config.data instanceof FormData) {
            config.headers["Content-Type"] = "multipart/form-data";
        } else {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Function for making GET requests 
export const getData = async (endpoint) => {
    try {
        const response = await apiSalesTracker.get(endpoint);
        return response.data;
    } catch (error) {
        console.error("GET Error:", error);
        throw error;
    }
};

// Function for making POST requests
export const postData = async (endpoint, data) => {
    try {
        const response = await apiSalesTracker.post(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("POST Error:", error);
        throw error;
    }
};

// Function for making PUT requests
export const putData = async (endpoint, data) => {
    try {
        const response = await apiSalesTracker.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("PUT Error:", error);
        throw error;
    }
};

// Function for making PATCH requests
export const patchData = async (endpoint, data) => {
    try {
        const response = await apiSalesTracker.patch(endpoint, data);
        return response.data;
    } catch (error) {
        console.error("PATCH Error:", error);
        throw error;
    }
};

// Function for making DELETE requests
export const deleteData = async (endpoint) => {
    try {
        const response = await apiSalesTracker.delete(endpoint);
        return response.data;
    } catch (error) {
        console.error("DELETE Error:", error);
        throw error;
    }
};


export const deleteDataNew = async (endpoint, data = {}) => {
    try {
        const token = localStorage.getItem("token");

        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
            },
            body: JSON.stringify(data),
        });

        return await response.json();
    } catch (error) {
        console.error('Delete request failed:', error);
        return { status: false, message: 'Request failed' };
    }
};




